import React, { useState } from "react";
import Image from "next/image";

import Head from 'components/Head';
import DesktopModalContainer from "components/Register/DesktopModalContainer";
import MobileModalContainer from "components/Register/MobileModalContainer";
import { redirectSelectPage } from "utils/loginFunctions";

export default function CompleteOnboarding() {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div>
      <Head />

      <main>

        <DesktopModalContainer>
          <div className="flex flex-row justify-between items-center mt-[16px] mx-[16px] relative h-[48px] ">
            <div className="flex flex-row justify-between items-center mt-[16px] mx-[16px] relative h-[48px] ">
              <div className="flex justify-center items-center ">
                <div
                  className="border-[1px] border-[#E7E7E7] 
            w-[48px] h-[48px] rounded-[8px] flex items-center justify-center
            cursor-pointer absolute top-0 left-0 "
                  onClick={redirectSelectPage}
                >
                  <Image
                    src="/svgs/close.svg"
                    alt=""
                    width={30}
                    height={30}
                  />
                </div>
              </div>
            </div>
            <div />
          </div>

          <div className="flex flex-col h-[100%] w-[100%] justify-between items-center py-[32px]">
            <div className="flex flex-col justify-center items-center">
              <div className="p-[52px] rounded-full bg-sorra-pink-light">
                <Image src='/svgs/mail-fill.svg' width={96} height={96} />
              </div>
              <div className="flex flex-col justify-center items-center">
                <div className="mt-[56px] text-[20px] font-[700] ">我們已向您發送確認電子郵件</div>
                <div className="mt-[16px] text-[14px] font-[400]">重置密碼鏈接已發送至您的電子郵件</div>
              </div>
            </div>
            <button className={`${isLoading ? 'bg-sorra-pink-light' : 'bg-sorra-pink'} w-[350px] h-[48px] rounded-[8px] text-[#fff] flex flex-row justify-center items-center`} onClick={() => {
              setIsLoading(true)
              redirectSelectPage()
            }}>
              {isLoading ? '載入中' : '確認'}
            </button>
          </div>
        </DesktopModalContainer>

        <MobileModalContainer>

          <div className="flex flex-col h-full w-full">
            <div className="flex flex-row justify-between items-center mt-[16px] mx-[16px] relative h-[48px] ">
              <div className="flex justify-center items-center ">
                <div
                  className="border-[1px] border-[#E7E7E7] 
            w-[48px] h-[48px] rounded-[8px] flex items-center justify-center
            cursor-pointer absolute top-0 left-0 "
                  onClick={redirectSelectPage}
                >
                  <Image
                    src="/svgs/close.svg"
                    alt=""
                    width={30}
                    height={30}
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col h-[100%] w-[100%] justify-between items-center py-[32px]">
              <div className="flex flex-col justify-center items-center">
                <div className="p-[52px] rounded-full bg-sorra-pink-light">
                  <Image src='/svgs/mail-fill.svg' width={96} height={96} />
                </div>
                <div className="flex flex-col justify-center items-center">
                  <div className="mt-[56px] text-[20px] font-[700] ">我們已向您發送確認電子郵件</div>
                  <div className="mt-[16px] text-[14px] font-[400]">重置密碼鏈接已發送至您的電子郵件</div>
                </div>
              </div>
              <button className={`${isLoading ? 'bg-sorra-pink-light' : 'bg-sorra-pink'} w-[350px] h-[48px] rounded-[8px] text-[#fff] flex flex-row justify-center items-center`} onClick={() => {
                setIsLoading(true)
                redirectSelectPage()
              }}>
                {isLoading ? '載入中' : '確認'}
              </button>
            </div>
          </div>

        </MobileModalContainer>

      </main>
    </div>
  )
}